import React, { useContext } from 'react'
import { DesignContext } from 'contexts/DesignContext'
import { vanillaRenderers, vanillaCells } from '@jsonforms/vanilla-renderers'
import FormControl, { formControlTester } from './control/formComponent/Control'
import { JsonForms } from '@jsonforms/react'
import FormLoading from 'components/Loader/FormLoading'

// สำหรับ Layout ที่มาจากการ Load Form อื่น ภายใน container
const FormComponentLayout = ({
  schema,
  uischema,
  data,
  config = {},
  isOpenModal,
  isDetailPanel,
}) => {
  const designContext = useContext(DesignContext)
  const { jsonForm } = designContext

  const renderers = [
    ...vanillaRenderers,
    { tester: formControlTester, renderer: FormControl },
  ]

  if (Object.keys(schema).length === 0) {
    return <FormLoading />
  }

  return (
    <JsonForms
      data={data}
      schema={schema || jsonForm.uischema}
      uischema={uischema || jsonForm.uischema}
      config={{ ...config, isOpenModal, isDetailPanel }}
      renderers={renderers}
      cells={vanillaCells}
    />
  )
}

export default FormComponentLayout
